export const PARTNERS = [
  {
    name: "Dryserve",
    href: "https://www.dryserve.co.uk/",
    image: "/partners/dryserve.avif",
  },
  {
    name: "Gardner Mechanical",
    href: "https://www.gardnermechanical.co.uk/",
    image: "/partners/gms.avif",
  },
  {
    name: "Ariana Pharmacy",
    href: "https://www.arianapharmacy.co.uk/",
    image: "/partners/ariana-pharmacy.avif",
  },
  {
    name: "Rose May Hotel",
    href: "https://rosemayhotel.com/",
    image: "/partners/rose-may-hotel.png",
  },
  {
    name: "Westminster Kitchen",
    href: "https://www.westminsterkitchen.com/",
    image: "/partners/westminster-kitchen.avif",
  },
  {
    name: "St Teresa's Academy",
    href: "https://www.st-teresas.wokingham.sch.uk/",
    image: "/partners/st-teresas-academy.avif",
  },
  {
    name: "Locatrix",
    href: "https://www.locatrix.com/",
    image: "/partners/locatrix.avif",
  },
  {
    name: "Window Flowers",
    href: "https://windowflowers.com/",
    image: "/partners/window-flowers.avif",
  },
  {
    name: "PAUL Bakery",
    href: "https://www.paul-uk.com/",
    image: "/partners/paul-bakery.png",
  },
];
